<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>工单系统</el-breadcrumb-item>
            <el-breadcrumb-item>我发起的工单</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="text-align:left">
        <el-col :span="24">
          <el-form :model="searchForm" :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-input
                size="small"
                clearable
                v-model="searchForm.OrderTitle"
                placeholder="请输入工单名称"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-select filterable v-model="searchForm.OrderServiceWinID" clearable size="small">
                <el-option
                  v-for="(item,index) in winOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select filterable v-model="searchForm.OrderState" clearable size="small">
                <el-option
                  v-for="(item,index) in stateOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" icon="el-icon-search" @click="GetUserCreateList">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table
            :data="taskList"
            style="width: 100%"
            row-key="ID"
            v-loading="loading"
            size="small"
            @row-click="rowClick"
          >
            <el-table-column prop="OrderTitle" label="工单标题"></el-table-column>
            <el-table-column prop="SubmitterName" label="提交人"></el-table-column>
            <el-table-column prop="MainDeptsName" label="提交人部门"></el-table-column>
            <el-table-column prop="SeatNumber" label="座位号"></el-table-column>
            <el-table-column prop="CreateTime" label="提交时间"></el-table-column>
            <el-table-column prop="ServiceName" label="服务类型"></el-table-column>
            <el-table-column prop="OrderState" :formatter="orderStateFormatter" label="状态"></el-table-column>
          </el-table>
          <el-row style="margin-top:10px">
            <el-col :span="24">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="pageSizes"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                style="float:right"
              ></el-pagination>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-dialog
        title="沟通记录"
        :wrapperClosable="wrapperClosable"
        :visible.sync="CommunicationVisible"
      >
        <el-row :gutter="10">
          <el-col :span="16">
            <JwChat
              :taleList="list"
              width="100%"
              height="500px"
              @enter="bindEnter"
              v-model="inputMsg"
              :toolConfig="tool"
            />
          </el-col>

          <el-col :span="8" style="text-align:left">
            <p class="contentP">提交人：{{task.SubmitterName}}</p>
            <p class="contentP">提交人部门：{{task.MainDeptsName}}</p>
            <p class="contentP">提交人电话：{{task.Phone}}</p>
            <p class="contentP">座位号：{{task.SeatNumber}}</p>
            <p class="contentP">问题：{{task.OrderTitle}}</p>
            <p class="contentP">描述：</p>
            <p class="sub">{{task.ContentDescription}}</p>
            <p class="contentP">截图：</p>
            <div v-if="task.Picture">
              <el-image
                v-for="(img,index) in task.Picture"
                :key="index"
                style="width: 50px; height: 50px"
                :src="img"
                :preview-src-list="task.Picture"
              ></el-image>
            </div>
            <div v-if="canRate">
              <p class="contentP">服务满意度评分：</p>
              <el-form>
                <el-form-item>
                  <el-rate
                    :disabled="rateDisabled"
                    @change="RateChange"
                    show-score
                    allow-half
                    v-model="task.Evaluation"
                  ></el-rate>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <uploader @UploaderHandler="uploaderHandler" :dialogUploadVisible.sync="dialogUploadVisible"></uploader>
    </el-card>
  </div>
</template>
<script>
import {
  GetMyOrderDetailsList,
  GetOrderRecord,
  OrderRecordAdd,
  GetOrderSerivceWin,
  UpdateOrderDetailRate
} from "../../until/ZeusApiSDK/Logic/OrderServiceLogic";
import {
  GetCurrentUserInfo,
  GetGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
import { GetSingeleUser } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import uploader from "../../views/Common/Uploader";
export default {
  data() {
    return {
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      taskList: [],
      task: {},
      currentUser: {},
      CommunicationVisible: false,
      modal: false,
      wrapperClosable: false,
      list: [],
      inputMsg: "",
      dialogUploadVisible: false,
      searchForm: {
        OrderState: "",
        OrderServiceWinID: "",
        OrderTitle: "",
        SubmitterName: ""
      },
      tool: {
        show: ["img"],
        callback: this.toolEvent
      },
      avarUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      stateOptions: [
        { value: "0", label: "待处理" },
        { value: "1", label: "处理中" },
        { value: "2", label: "已结束，待评价" },
        { value: "3", label: "已评价" },
        { value: "-1", label: "全部" }
      ],
      winOptions: [],
      canRate: false,
      rateDisabled: false
    };
  },
  created() {
    this.currentUser = GetCurrentUserInfo();
    this.GetUserCreateList();
    this.GetServiceWinOptions();
  },
  methods: {
    //更改每页显示条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetUserCreateList();
    },
    //翻页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetUserCreateList();
    },
    GetServiceWinOptions: function() {
      GetOrderSerivceWin().then(res => {
        if (res) {
          for (let r of res) {
            var option = { value: r.ID, label: r.ServiceName };
            this.winOptions.push(option);
          }
        }
      });
    },
    rowClick: function(row) {
      this.canRate = false;
      this.rateDisabled = false;
      this.CommunicationVisible = true;
      this.task = row;
      if (this.task.Picture) {
        if (!(this.task.Picture instanceof Array)) {
          this.task.Picture = this.task.Picture.split(",");
        }
      } else {
        this.task.Picture = [];
      }
      if (this.task.OrderState == 2) {
        this.canRate = true;
      } else if (this.task.OrderState == 3) {
        this.canRate = true;
        this.rateDisabled = true;
      }
      if (this.task.Evaluation) {
        this.task.Evaluation = Number(this.task.Evaluation);
      } else {
        this.task.Evaluation = 0;
      }
      this.getChatList();
    },
    GetUserCreateList: function() {
      this.loading = true;
      this.searchForm.SubmitterName = this.currentUser.TrueName;
      this.searchForm.pageIndex = this.pageIndex;
      this.searchForm.pageSize = this.pageSize;
      if (!this.searchForm.OrderState) {
        this.searchForm.OrderState = "-1";
      }
      GetMyOrderDetailsList(this.searchForm).then(res => {
        this.totalCount = res.TotalCount;
        this.taskList = res.List;
        this.loading = false;
      });
    },
    //刷新
    Refresh:function(){
      this.GetUserCreateList();
    },
    getChatList: function() {
      this.list = [];
      GetOrderRecord(this.task.ID).then(res => {
        if (res) {
          res.reverse();
          res.forEach(element => {
            var msg = "";
            if (element.Contents.startsWith("img")) {
              msg = this.setImgMsg(element.Contents);
            } else {
              msg = element.Contents;
            }
            var chatItem = {
              date: element.ChatTime,
              text: { text: msg },
              mine: this.CheckIsMine(element.PersonID),
              name: element.PersonName,
              img: this.GetAvarUrl(element.Avatar)
            };
            this.list.push(chatItem);
          });
        }
      });
    },
    CheckIsMine: function(senderId) {
      if (senderId == this.currentUser.UserId) {
        return true;
      } else {
        return false;
      }
    },
    GetAvarUrl: function(avar) {
      if (!avar) {
        return this.avarUrl;
      }
    },
    orderStateFormatter: function(row, column, cellValue, index) {
      if (cellValue == "0") {
        return "待处理";
      } else if (cellValue == "1") {
        return "处理中";
      } else if (cellValue == "2") {
        return "已结束，待评价";
      } else if (cellValue == "3") {
        return "已评价";
      }
    },
    bindEnter: function() {
      if (this.task.OrderState != "2") {
        var msg = this.inputMsg;
        if (!msg) return;
        GetGuid().then(id => {
          var userNameArr = this.currentUser.UserName.split("@");

          var chatItem = {
            ID: id,
            OrderDetailsID: this.task.ID,
            PersonID: this.currentUser.UserId,
            PersonName: this.currentUser.TrueName,
            PersonEntID: userNameArr[0],
            ChatTime: this.getNowDateStr,
            IsDelete: 0,
            Contents: msg
          };

          OrderRecordAdd(chatItem).then(res => {
            if(msg.startsWith("img"))
            {
              msg=this.setImgMsg(msg);
            }
            if (res == "success") {
              const msgObj = {
                date: this.getNowDateStr(),
                text: { text: msg },
                mine: true,
                name: this.currentUser.TrueName,
                img: this.avarUrl
              };
              this.list.push(msgObj);
              this.inputMsg = "";
            } else {
              this.$message({
                message: "发送失败",
                type: "warning",
                center: true
              });
            }
          });
        });
      } else {
        this.$message({
          message: "工单已结束",
          type: "warning",
          center: true
        });
      }
    },
    setImgMsg: function(imgContent) {
      var imgArr = imgContent.split(",");
      var imgMsg = '<img data-src="' + imgArr[1] + '"/>';
      return imgMsg;
    },
    toolEvent(type) {
      if (type == "img") {
        this.dialogUploadVisible = true;
      }
    },
    uploaderHandler: function(img) {
      this.inputMsg = "img," + img;
      this.bindEnter();
    },
    RateChange: function(val) {
      UpdateOrderDetailRate(this.task.ID, 3, val).then(res => {
        if (res == "success") {
          this.$message({
            message: "评分成功",
            type: "success",
            center: true
          });
          this.CommunicationVisible = false;
        } else {
          this.$message({
            message: "评分失败",
            type: "warning",
            center: true
          });
        }
      });
    },
    getNowDateStr: function() {
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      var date = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      return date;
    }
  },
  components: { uploader }
};
</script>
<style lang="less" scoped>
/deep/.sub {
  font-size: 12px;
  color: #8f8d8d;
  text-align: left;
  /* margin-top: 10px; */
}
/deep/.contentP {
  margin-top: 5px;
  margin-bottom: 5px;
}
/deep/.mainArea {
  margin: 20px;
  height: 30%;
}
/deep/.bottomInput {
  display: inline;
}
/deep/.web__main-user img {
  margin-top: 18px;
}
</style>